"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Thiana API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfReportTemplateShortcutOutput = instanceOfReportTemplateShortcutOutput;
exports.ReportTemplateShortcutOutputFromJSON = ReportTemplateShortcutOutputFromJSON;
exports.ReportTemplateShortcutOutputFromJSONTyped = ReportTemplateShortcutOutputFromJSONTyped;
exports.ReportTemplateShortcutOutputToJSON = ReportTemplateShortcutOutputToJSON;
var Metadata_1 = require("./Metadata");
var ReportTemplateShortcut_1 = require("./ReportTemplateShortcut");
/**
 * Check if a given object implements the ReportTemplateShortcutOutput interface.
 */
function instanceOfReportTemplateShortcutOutput(value) {
    if (!('data' in value) || value['data'] === undefined)
        return false;
    return true;
}
function ReportTemplateShortcutOutputFromJSON(json) {
    return ReportTemplateShortcutOutputFromJSONTyped(json, false);
}
function ReportTemplateShortcutOutputFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': (json['data'].map(ReportTemplateShortcut_1.ReportTemplateShortcutFromJSON)),
        'metadata': json['metadata'] == null ? undefined : (0, Metadata_1.MetadataFromJSON)(json['metadata']),
    };
}
function ReportTemplateShortcutOutputToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'data': (value['data'].map(ReportTemplateShortcut_1.ReportTemplateShortcutToJSON)),
        'metadata': (0, Metadata_1.MetadataToJSON)(value['metadata']),
    };
}
